import { Component, NgZone, OnInit } from '@angular/core'
import { Title } from '@angular/platform-browser'

import { ResourceService } from 'app/shared/resources/resource.service'
import { LocaleService } from 'app/shared/locale-service'
import { BookingsService } from '../bookings.service'
import { CookieService } from 'app/shared/cookie.service'
import { HybridService } from 'app/shared/hybrid/hybrid.service'
import { IUserBooking } from 'app/amendment/bookings/bookings.interfaces'
import { LayoutState } from 'app/shared/layout/layout-state'
import { TrackingService } from 'app/shared/tracking/tracking.service'
import { TrackingAmendmentStep } from 'app/shared/tracking/tracking-wire.interfaces'
import { OktaService } from 'app/okta/okta.service'

@Component({
    selector: 'sbw-bookings',
    templateUrl: './bookings.component.html',
    styleUrls: ['./bookings.component.css']
})
export class BookingsComponent implements OnInit {
    public activeBookings: IUserBooking[]
    public expiredBookings: IUserBooking[]
    public isAgent: boolean
    private locale: string

    constructor(
        private resourceService: ResourceService,
        private localeService: LocaleService,
        private bookingsService: BookingsService,
        private titleService: Title,
        private cookieService: CookieService,
        private hybridService: HybridService,
        private trackingService: TrackingService,
        private layoutState: LayoutState,
        private oktaService: OktaService,
        private zone: NgZone
        ) { }

    ngOnInit() {
        this.isAgent = localStorage.getItem('sbw_AgentGenericId') ? true : false;
        let authType = this.cookieService.getAuthType()
        if (authType === 'agent') {
            this.hybridService.replaceWindowLocation('/agent/bookings')
            return
        }

        this.locale = this.localeService.getLocale();
        this.resourceService.loadResources('Default', this.locale, ['Common', 'Account', 'Amendment', 'ContactDetails', 'Menu'].concat(this.isAgent ? ['Agent', 'MenuAgent'] : []))
        this.resourceService.get('TITLE_MY_BOOKINGS', false).subscribe(s => this.titleService.setTitle(s));


        if(!this.oktaService.oktaInUse() || (authType === 'agent' && this.isAgent) || (this.oktaService.oktaInUse() && this.oktaService.isLoggedIn())) {
            this.getData()
        }
        else {
            this.layoutState.setIsContentLoaded(true)
            this.oktaService.onOktaLoggedIn.subscribe(() => {
                this.zone.run(() => {
                   if(this.oktaService.isLoggedIn()){
                       this.getData()
                   }
                })
            })
        }
    }

    sortBookings(bookings: IUserBooking[], order: string): IUserBooking[] {
        return bookings.sort((a, b) => {
            let x = a[order]
            let y = b[order]
            return ((x < y) ? -1 : ((x > y) ? 1 : 0))
        })
    }

    private getData() {
        const sub = localStorage.getItem('sbw_Sub')
        this.bookingsService.getBookings(sub, this.locale).subscribe(s => {
            this.activeBookings = this.sortBookings(s.active, 'outbound')
            this.expiredBookings = this.sortBookings(s.expired, 'return')
            this.layoutState.setIsContentLoaded(true)
            this.trackingService.trackAmendment(TrackingAmendmentStep.BOOKINGS)
            this.layoutState.setIsContentLoaded(true)
        })
    }
}
